var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_98_4756",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_98_4756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1069 32.4999C9.39056 32.4999 8.77701 32.2445 8.26623 31.7338C7.75545 31.223 7.50006 30.6094 7.50006 29.8931V24.938H9.59402V29.8931C9.59402 30.0213 9.64745 30.1388 9.75431 30.2457C9.86114 30.3525 9.97867 30.406 10.1069 30.406H29.8931C30.0214 30.406 30.1389 30.3525 30.2457 30.2457C30.3526 30.1388 30.406 30.0213 30.406 29.8931V24.938H32.5V29.8931C32.5 30.6094 32.2446 31.223 31.7338 31.7338C31.223 32.2445 30.6095 32.4999 29.8931 32.4999H10.1069ZM18.9531 26.1666V11.2584L14.5171 15.6836L13.0258 14.1858L20 7.21155L26.9743 14.1858L25.4829 15.6836L21.047 11.2584V26.1666H18.9531Z",
    fill: "#1C1B1F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.41cb39b775c0f4874f4a5b88ea4520d2.svg";
export { ForwardRef as ReactComponent };